import React, { PureComponent } from 'react';

import getYear from 'date-fns/get_year';

import { unit } from '@zego/theme';

import View from '@zego/components/atoms/View';

import Input from './Input';

class SplitDateInput extends PureComponent {
  constructor(props) {
    super(props);
    let day = '';
    let month = '';
    let year = '';

    const { value, initialValue } = props;

    if (initialValue) {
      year = initialValue.substring(0, 4);
      month = initialValue.slice(5, 7);
      day = initialValue.slice(8);
    }

    if (value) {
      [year, month, day] = props.value.split('-');
    }

    this.state = {
      day,
      month,
      year,
    };
  }

  _onChange = () => {
    const { onChange, showDay } = this.props;
    const { day, month, year } = this.state;

    if (onChange) {
      if (
        showDay === true &&
        year.length === 4 &&
        month.length >= 1 &&
        day.length >= 1
      ) {
        onChange(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`);
      } else if (showDay === false && year.length === 4 && month.length >= 1) {
        onChange(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '01')}`);
      } else onChange('');
    }
  };

  _onChangeDay = event => {
    if (event.target.value.length <= 2) {
      this.setState({ day: event.target.value }, () => {
        this._onChange();

        const intDay = parseInt(this.state.day, 10);

        if (this.state.day.length === 2 && intDay <= 31 && intDay > 0) {
          this._inputMonth.focus();
        }
      });
    }
  };

  _onChangeMonth = event => {
    if (event.target.value.length <= 2) {
      this.setState({ month: event.target.value }, () => {
        this._onChange();

        const intMonth = parseInt(this.state.month, 10);

        if (this.state.month.length === 2 && intMonth <= 12 && intMonth > 0) {
          this._inputYear.focus();
        }
      });
    }
  };

  _onChangeYear = event => {
    if (event.target.value.length <= 4) {
      this.setState({ year: event.target.value }, () => {
        this._onChange();
      });
    }
  };

  render() {
    const { name, showDay, error, onBlur, onFocus, limitMaxYear } = this.props;
    const { day, month, year } = this.state;

    const dayAndMonthWidth = showDay ? 'calc(32% - 8px)' : 'calc(40% - 8px)';
    const yearWidth = showDay ? '36%' : '60%';
    const maxYear = limitMaxYear === false ? null : getYear(new Date());

    return (
      <View
        css={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        {showDay ? (
          <Input
            name={name ? `${name}-day` : null}
            ref={input => (this._inputDay = input)}
            type="number"
            onChange={this._onChangeDay}
            value={day}
            min={1}
            max={31}
            placeholder="DD"
            error={error}
            onFocus={onFocus}
            css={{ width: dayAndMonthWidth, marginRight: unit(1) }}
          />
        ) : null}
        <Input
          name={name ? `${name}-month` : null}
          ref={input => (this._inputMonth = input)}
          type="number"
          onChange={this._onChangeMonth}
          onFocus={onFocus}
          value={month}
          min={1}
          max={12}
          placeholder="MM"
          error={error}
          css={{ width: dayAndMonthWidth, marginRight: unit(1) }}
        />
        <Input
          name={name ? `${name}-year` : null}
          ref={input => (this._inputYear = input)}
          type="number"
          onChange={this._onChangeYear}
          value={year}
          min={1917}
          max={maxYear}
          placeholder="YYYY"
          error={error}
          onBlur={onBlur}
          onFocus={onFocus}
          css={{ width: yearWidth }}
        />
      </View>
    );
  }
}

export default SplitDateInput;
